import moment from 'moment';

type DateFormat = 'DD/MM/YYYY' | 'MM-DD-YYYY' | 'YYYY-MM-DD' | 'YYYY/MM/DD' | 'DD-MM-YYYY';

export const getCurrentDay = (format:DateFormat): { currentDay: string } => {
  const currentDay = moment().format(format);

  return {
    currentDay
  };
}
